import React from 'react';
import noop from 'lodash/noop';
import { ButtonItem } from '@atlaskit/menu';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { getNextgenSettingsWorkflowUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';
import { RouterActions } from '@atlassian/react-resource-router';
import messages from './messages.tsx';

export type OwnProps = {
	isDisabled: boolean;
	issueTypeId: string;
	projectKey: string;
};

export type Props = OwnProps;

const ManageWorkflowMenuItem = (props: Props) => {
	const { formatMessage } = useIntl();
	const { isDisabled, projectKey, issueTypeId } = props;

	return (
		<RouterActions>
			{({ push }) => {
				const onClick = issueTypeId
					? () => push(getNextgenSettingsWorkflowUrl(SOFTWARE_PROJECT, projectKey, issueTypeId))
					: noop;

				return (
					<ButtonItem isDisabled={isDisabled || !issueTypeId} onClick={onClick}>
						{formatMessage(messages.displayText)}
					</ButtonItem>
				);
			}}
		</RouterActions>
	);
};

export default ManageWorkflowMenuItem;
